import React, { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { FiPhone, FiMenu, FiX, FiMessageCircle } from 'react-icons/fi';

const navItems = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About' },
  { path: '/products', label: 'Products' },
  { path: '/distribution-network', label: 'Distribution Network' },
  { path: '/become-dealer', label: 'Become Dealer' },
  { path: '/careers', label: 'Careers' },
  { path: '/contact', label: 'Contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    document.body.style.overflow = '';
  }, [pathname]);

  const toggleMobile = () => {
    const next = !mobileOpen;
    setMobileOpen(next);
    document.body.style.overflow = next ? 'hidden' : '';
  };

  const headerClass = `main-header ${!isHome || scrolled ? 'scrolled' : 'transparent'}`;

  return (
    <>
      <header className={headerClass}>
        <div className="container">
          <div className="header-inner">
            <Link to="/" className="nav-logo">
              <div className="logo-icon">AE</div>
              <div className="logo-text">
                <span className="logo-name">Avivan Enterprises</span>
                <span className="logo-tagline">FMCG Distribution Partner</span>
              </div>
            </Link>

            <nav className="nav-links">
              {navItems.map(item => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === '/'}
                  className={({ isActive }) => `nav-link-item ${isActive ? 'active' : ''}`}
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>

            <div className="nav-ctas">
              <a href="tel:+919876543210" className="btn-call">
                <FiPhone size={13} />
                Call Now
              </a>
              <Link to="/contact" className="btn-enquiry">
                <FiMessageCircle size={13} />
                Enquiry
              </Link>
              <button className="hamburger" onClick={toggleMobile} aria-label="Menu">
                {mobileOpen ? <FiX size={20} /> : <FiMenu size={20} />}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Nav */}
      <nav className={`mobile-nav ${mobileOpen ? 'open' : ''}`}>
        <div style={{ position: 'absolute', top: 24, right: 24 }}>
          <button
            onClick={toggleMobile}
            style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: '#fff', width: 42, height: 42, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
          >
            <FiX size={20} />
          </button>
        </div>
        <div style={{ marginBottom: 32 }}>
          <div style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 800, fontSize: '1.4rem', color: '#fff' }}>
            Avivan <span style={{ color: 'var(--accent)' }}>Enterprises</span>
          </div>
          <div style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.45)', textTransform: 'uppercase', letterSpacing: '2px', marginTop: 4 }}>
            FMCG Distribution Partner
          </div>
        </div>
        {navItems.map(item => (
          <Link key={item.path} to={item.path} className="mobile-nav-link">
            {item.label}
          </Link>
        ))}
        <div className="mobile-nav-ctas">
          <a href="tel:+919876543210" className="btn-primary-c" style={{ justifyContent: 'center' }}>
            <FiPhone size={15} /> +91 98765 43210
          </a>
          <Link to="/become-dealer" className="btn-accent-c" style={{ justifyContent: 'center' }}>
            Become a Dealer
          </Link>
        </div>
      </nav>
    </>
  );
}
